import{a}from"./chunk-EBMEXURY.mjs";var e=class extends a{};export{e as a};
//# sourceMappingURL=chunk-XJJVJOX5.mjs.map